import type { QSetStatus } from '@exam-management/graphql';
import { type LabelProps, Label } from '@shared/components';

import { QSET_COLOR_STATUS, QSET_STATUS_TEXT } from './constants';

export interface QSetStatusTagProps extends LabelProps {
  status: QSetStatus;
}

export default function QSetStatusTag(props: Readonly<QSetStatusTagProps>) {
  const { status, ...restProps } = props;

  return (
    <Label color={QSET_COLOR_STATUS[status]} variant='outlined' {...restProps}>
      {QSET_STATUS_TEXT[status]}
    </Label>
  );
}
